import {clone, get_bemto_tag_type, get_bemto_tag_content_type, bemto_tag_metadata} from "./vendor/bemto-functions";

window.clone = clone;
window.get_bemto_tag_type = get_bemto_tag_type;
window.get_bemto_tag_content_type = get_bemto_tag_content_type;
window.bemto_tag_metadata = bemto_tag_metadata;

if (NODE_ENV === 'development') {
    // import('./pug/components.pug');
    // import('./pug/index.pug');
    // import('./pug/catalog.pug');
    // import('./pug/contact.pug');
    // import('./pug/pickup.pug');
    // import('./pug/payment.pug');
    // import('./pug/delivery.pug');
    // import('./pug/faq.pug');
    // import('./pug/product.pug');
    // import('./pug/order.pug');
    // import('./pug/order-all.pug');
    // import('./pug/order-last.pug');
    // import('./pug/order-ok.pug');
    // import('./pug/lk.pug');
    // import('./pug/lk-bonuses.pug');
    // import('./pug/lk-settings.pug');
}

// import icons
//=====================================
import './js/svg-sprite'

// import styles
//=====================================
import "swiper/dist/css/swiper.min.css"
import './js/uikit/_import.scss'
import 'choices.js/public/assets/styles/choices.min.css'
import 'pikaday/css/pikaday.css'
import 'nouislider/distribute/nouislider.min.css'
// import 'simplebar/dist/simplebar.css'
import './sass/main.sass'

import {forEach, getContainerOffset} from "./js/helpers";

const firstContainer = document.querySelector('.container');

const setPropContainerOffset = (container) => document.documentElement.style.setProperty('--container-left-offset', getContainerOffset(container) + 'px');
setPropContainerOffset(firstContainer);
window.addEventListener('resize', () => {
  setPropContainerOffset(firstContainer)
});

// import components
//=====================================
import './components/header/header.js'
import './components/popup-mobile/popup-mobile.js'
import './components/sliderMain/sliderMain.js'

import {item} from './components/item/item.js';
forEach(document.querySelectorAll(".item"), itemEl => item(itemEl));

import './components/itemsBlock/itemsBlock.js'
import './components/flowsBlock/flowsBlock.js'
import './components/itemsBlog/itemsBlog.js'
import './components/b-toggle/b-toggle.js'
import './components/footer/footer.js'
import './components/page-catalog/catalog.js'
import './components/contact/contact.js'
import './components/gallery/gallery.js'
import './components/page-delivery/page-delivery.js'
import './components/page-product/page-product.js'
import './components/faq/faq.js'
import './components/page-order/page-order'
import './components/page-lk/page-lk'
import './components/itemSm/itemSm'
import './components/cart-order/cart-order'
import './components/modals/modals'
// import './components/popover/popover'
import './components/sliderMini'

import {pane} from './components/pane/pane';
forEach(document.querySelectorAll('.pane'), pane);

// import scripts
//=====================================
import './js/dinamic-links.js'
import './js/forms.js'
// import './js/smoothScroll.js'
// import './js/lazy-video.js'

import { mobileDevice } from './js/helpers'

if (mobileDevice()) document.body.classList.add('isMobileDevice');

import UIkit from './js/uikit/uikit';
window.UIkit = UIkit;
